"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

export const hostPageToolRegistry = {
  get_current_page: {
    kind: "step",
    category: "research",
    view: lazy(() =>
      import("./views").then(({ GetCurrentPageToolView }) => ({
        default: GetCurrentPageToolView,
      }))
    ),
  },
  set_theme: {
    kind: "step",
    category: "create",
    view: lazy(() =>
      import("./views").then(({ SetThemeToolView }) => ({
        default: SetThemeToolView,
      }))
    ),
  },
} satisfies ToolUIRegistry;
